<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <HeaderPanel
        title="รายการตั้งยอด"
        :filter="filter"
        @search="handleSearch"
        @clear="clearFilter"
      >
        <b-button
          variant="filter"
          @click="$router.push('/invoice-consignment/0')"
          class="btn-filter mr-2"
        >
          <font-awesome-icon icon="plus" class="pointer icon" />
          <span class="d-none d-md-block ml-2">สร้าง</span>
        </b-button>
        <template v-slot:filter-option>
          <b-col>
            <InputText
              v-model="filter.search"
              textFloat="ชื่อเอกสาร / ใบปลดหนี้"
              placeholder="ชื่อเอกสาร / ใบปลดหนี้"
              type="text"
              name="inventory_search"
              @onDataChange="handleSearch"
              class="mb-2"
            />
          </b-col>
        </template>
      </HeaderPanel>
      <div class="bg-white border-red mt-3">
        <b-tabs v-model="tabIndex">
          <b-tab title="ยังไม่เคลียร์ยอด"></b-tab>
          <b-tab title="เคลียร์แล้ว"></b-tab>
        </b-tabs>
        <b-row>
          <b-col>
            <b-table
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
              class="table-main"
              :no-border-collapse="false"
            >
              <template v-slot:cell(expand)="row">
                <div>
                  <font-awesome-icon
                    v-if="!row.detailsShowing"
                    @click="row.toggleDetails"
                    icon="chevron-down"
                    class="pointer"
                    size="sm"
                  />
                  <font-awesome-icon
                    v-else
                    @click="row.toggleDetails"
                    icon="chevron-up"
                    class="pointer"
                    size="sm"
                  />
                </div>
              </template>
              <template v-slot:cell(invoice_no)="data">
                <router-link
                  :to="'/invoice-consignment/detail/' + data.item.id"
                >
                  <u>{{ data.item.invoice_no }}</u>
                </router-link>
              </template>
              <template v-slot:cell(created_time)="data">
                <div>
                  {{ $moment(data.item.created_time).format("DD/MM/YYYY") }}
                </div>
                <div>
                  {{ $moment(data.item.created_time).format("HH:mm:ss") }}
                </div>
              </template>

              <template v-slot:cell(invoice_tax_name)="data">
                <div class="text-left">
                  <div class="text-underline pointer">
                    {{ data.item.invoice_tax_name }}
                  </div>

                  <div class="text-gray">
                    {{ data.item.invoice_tax_payer_number }}
                  </div>

                  <div class="text-gray">
                    {{ data.item.invoice_tax_tel }}
                  </div>
                </div>
              </template>
              <template v-slot:cell(total_amount)="data">
                <div class="">
                  {{ data.item.total_amount | numeral("0,0.00") }}
                </div>
              </template>
              <template v-slot:cell(net_amount)="data">
                <div class="">
                  {{ data.item.net_amount | numeral("0,0.00") }}
                </div>
              </template>
              <template v-slot:cell(outstanding_amount)="data">
                <div class="">
                  {{ data.item.outstanding_amount | numeral("0,0.00") }}
                </div>
              </template>
              <template v-slot:cell(user_transaction_status_name)="data">
                <div class="text-success">
                  {{ data.item.user_transaction_status_name }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <font-awesome-icon
                  icon="pencil-alt"
                  class="pointer text-warning"
                  @click="
                    $router.push(`/invoice-consignment/detail/${data.item.id}`)
                  "
                ></font-awesome-icon>
              </template>
              <template #row-details="row">
                <b-table
                  responsive
                  hover
                  :fields="subfields"
                  :items="subItems[row.index].data"
                  class="table-sub px-4"
                  show-empty
                  :busy="subItems[row.index].isBusy"
                  empty-text="No matching records found"
                >
                  <template v-slot:cell(invoice_no)="data">
                    <router-link :to="'/cn-consignment/detail/' + data.item.id">
                      <u>{{ data.item.invoice_no }}</u>
                    </router-link>
                  </template>
                  <template v-slot:cell(created_time)="data">
                    <div>
                      {{ $moment(data.item.created_time).format("DD/MM/YYYY") }}
                    </div>
                    <div>
                      {{ $moment(data.item.created_time).format("HH:mm:ss") }}
                    </div>
                  </template>
                  <template v-slot:cell(total_amount)="data">
                    <div class="">
                      {{ data.item.total_amount | numeral("0,0.00") }}
                    </div>
                  </template>
                  <template v-slot:cell(net_amount)="data">
                    <div class="">
                      {{ data.item.net_amount | numeral("0,0.00") }}
                    </div>
                  </template>
                  <template v-slot:cell(user_transaction_status_name)="data">
                    <div
                      :class="{
                        'text-success':
                          data.item.user_transaction_status_id == 1,
                        'text-error': data.item.user_transaction_status_id == 2,
                      }"
                    >
                      {{ data.item.user_transaction_status_name }}
                    </div>
                  </template>
                </b-table>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderPanel from "@/components/HeaderPanel";
import Pagination from "@/components/Pagination";
import InputText from "@/components/inputs/InputText";

import { mapGetters } from "vuex";

export default {
  components: {
    OtherLoading,
    Pagination,
    HeaderPanel,
    InputText,
  },
  data() {
    return {
      fields: [
        { key: "expand", label: "" },
        {
          key: "invoice_no",
          label: "หมายเลขเอกสาร",
          thStyle: { width: "15%" },
        },
        {
          key: "gp_barcode_name",
          label: "GP Barcode",
          thStyle: { width: "15%" },
        },

        {
          key: "invoice_tax_name",
          label: "ลูกค้า",
          class: "text-left pointer",
          thStyle: { width: "15%" },
        },
        {
          key: "net_amount",
          label: "ยอดสุทธิ",
        },
        {
          key: "outstanding_amount",
          label: "ยอดหนี้คงเหลือ",
        },
        {
          key: "created_time",
          label: "วันที่ / เวลา",
          tdClass: "text-center",
        },
        {
          key: "user_transaction_status_name",
          label: "สถานะ",
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          tdClass: "text-center",
        },
      ],
      items: [],
      isBusy: false,
      isLoadingData: false,
      checkAll: false,
      selectAllCb: false,
      rows: 0,
      showing: 1,
      showingTo: 10,
      checkboxActive: false,
      checkboxInactive: false,
      filter: {
        branch_id: this.branchId,
        search: "",
        gp_barcode_id: "",
        date_from: "",
        date_to: "",
        page: 1,
        take: 10,
      },
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      selected: 0,
      isLoading: true,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      subfields: [
        {
          key: "invoice_no",
          label: " ใบปลดหนี้",
        },

        {
          key: "total_amount",
          label: "ยอดสุทธิ",
        },

        {
          key: "net_amount",
          label: "ยอดหนี้คงเหลือ",
        },
        {
          key: "total_quantity",
          label: "สินค้า",
        },
        {
          key: "created_time",
          label: "วันที่ / เวลา",
          tdClass: "text-center",
        },
        {
          key: "user_transaction_status_name",
          label: "สถานะ",
          tdClass: "text-center",
        },
      ],
      subItems: [],
      tabIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  created: async function () {
    this.filter.branch_id = this.branchId;
    await this.getList();
  },
  watch: {
    tabIndex(newVal) {
      this.filter.is_cleared = newVal;
      this.getList();
    },
  },

  methods: {
    getList: async function () {
      //         {
      //     "invoiceNo": "DEP-ZEN1604680003",
      //     "depositType": 2,
      //     "depositStatus": 0,
      //     "createdTime": "0001-01-01T00:00:00",
      //     "pickupDate": "2025-04-11T01:40:47",
      //     "memberId": "1230000504363",
      //     "firstNameTh": "Chaiyawat",
      //     "lastNameTh": "Chongsuwanit",
      //     "firstNameEn": "",
      //     "lastNameEn": "",
      //     "name": "ทองทดสอบเท่าไหร่ไม่รู้"
      // }
      this.isBusy = true;

      this.isLoadingData = true;
      await this.axios
        .post(`${this.$baseUrl}/InvoiceConsignment/List`, this.filter)
        .then((data) => {
          this.isLoading = false;
          if (data.result == 1) {
            this.items = data.detail.consignments;
            this.subItems = this.items.map((x) => ({
              data: x.cns,
              isBusy: false,
            }));
            this.rows = data.detail.total_count;
            this.isLoadingData = false;
          }
        });

      this.isBusy = false;
    },
    handleSearch(value) {
      this.pagination(1);
    },
    pagination(page) {
      this.filter.page = page;
      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;

      this.getList();
    },
    clearFilter() {
      this.filter = {
        filter: {
          branch_id: this.branchId,
          search: "",
          gp_barcode_id: "",
          date_from: "",
          date_to: "",
          page: 1,
          take: 10,
          is_cleared: 0,
        },
      };
      this.getList();
    },
    handleTransfer(item) {
      this.$refs.modalTransfer.show(item, "otherBranch");
    },
    reloadOtherBranch() {
      this.$refs.modalOtherBranch.getOtherBranchInventory();
      this.getList();
    },
    // async getSubInvoice(row) {
    //   if (this.subItems[row.index].total !== null) {
    //     row.toggleDetails();
    //     return;
    //   }
    //   this.subItems[row.index].isBusy = true;
    //   row.toggleDetails();
    //   const product_id = row.item.product_id;
    //   const response = await this.axios(
    //     `/Inventory/GetSubInventory/${this.filter.branch_id}/${product_id}`
    //   );
    //   this.subItems[row.index].data = response.data.detail.data;
    //   this.subItems[row.index].total = response.data.detail.total;
    //   this.subItems[row.index].isBusy = false;
    // },
  },
};
</script>

<style lang="scss" scoped>
.time {
  color: #afafaf;
}
.line-clamp2 {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.badge {
  font-size: 85%;
  background-color: var(--secondary-color);
  color: var(--primary-color);
  max-width: max-content;
  font-weight: 100;
}
.badge-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.info {
  margin: 0 5px;
  font-size: 24px;
  color: #000 !important;
}

::v-deep .table-main {
  table {
    min-width: max-content;
  }
}
</style>
